import { addParamsToUrl } from '@zapier/url-utils';
import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildDowngradeWarningUrl = (
  fromPlanName: string,
  toPlanName: string,
  interval: Interval,
  selectedCurrency?: string
): string => {
  const url = encodeURI(
    `/app/billing/plans/downgrade-plan/${fromPlanName.toLocaleLowerCase()}/${toPlanName.toLocaleLowerCase()}/${interval}`
  );

  return addParamsToUrl(url, { currency: selectedCurrency }, true);
};
